/**
 * Hook para obtener token por address.
 */
import type { TokenDto } from "common/models";
import { useQuery } from "react-query";
import { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { Queries } from "ui/query/queries";
import { tokenApi } from "../api/tokenApi";

export function useGetToken<TData = TokenDto>(
    tokenAddress?: string,
    { enabled = true, ...options }: UseCustomQueryOptions<TokenDto, unknown, TData, (string | undefined)[]> = {}
) {
    return useQuery(
        [Queries.GET_TOKEN, tokenAddress],
        () => tokenApi.findByAddress(tokenAddress as string),
        {
            enabled: Boolean(tokenAddress && enabled),
            ...options,
        }
    );
}
